/*
 ## External Dependencies ##
 - agendor-web/public_html/src/javascript/obj/Negocio.js -> to use function NegocioUI.handleSelOrderBy
 */

var ListingActions = require("app/shared/actions/listing-actions");

var ListingSort = React.createClass({
	handleSelOrderBy: function(e){
		ListingActions.orderBy(e.target.value);
	},
	render: function () {
		var optionsOrderBy = [];
		this.props.orderBy.options[this.props.env].map(function(option) {
			optionsOrderBy.push(<option key={option.value} value={option.value}>{option.label}</option>);
		}.bind(this));

		return (
			<span className="selectGroup medium">
				<select value={this.props.orderBy.value} className="dropdownDefault b-light" name="orderBy" id="filter-order-by" onChange={this.handleSelOrderBy}>
					{optionsOrderBy}
				</select>
				<span className="dropdown-caret custom-glyphicon icon-chevron-down"></span>
			</span>
		);
	}
});

module.exports = ListingSort;



// WEBPACK FOOTER //
// ./app/shared/components/List/listing-sort.jsx